export default __webpack_public_path__ + "static/media/About_BG-02.cd3ed977.png";